import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { AssetStorageItemDto } from 'src/Services/API/generated';

export const useAddExternalLink = (
  options?: UseMutationOptions<
    AssetStorageItemDto,
    unknown,
    { name: string; url: string; path: string }
  >
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<AssetStorageItemDto, unknown, { name: string; url: string; path: string }>(
    'add-external-link',
    async ({ name, url, path }) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await assetStorageApi.assetStorageControllerAddExternalLink(assetId, {
        name,
        url,
        path,
      });
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries({ queryKey: ['fetch-documents', assetId] });
      },
    }
  );
};
